import { postChannel } from '../../services/api/channel.api';
import { CREATE_CHANNEL_REQUEST, CREATE_CHANNEL_SUCCESS, CREATE_CHANNEL_FAILURE } from '../types';
import { transformError } from '../../transforms/error';

export default {
	namespaced: true,

	state: {
		isLoading: false,
		error: null,
	},

	mutations: {
		[CREATE_CHANNEL_REQUEST](state) {
			state.isLoading = true;
			state.error = null;
		},
		[CREATE_CHANNEL_SUCCESS](state) {
			state.isLoading = false;
		},
		[CREATE_CHANNEL_FAILURE](state, error) {
			state.isLoading = false;
			state.error = transformError(error);
		},
	},

	actions: {
		async createChannel({ commit }, params) {
			try {
				commit(CREATE_CHANNEL_REQUEST);
				await postChannel(params);
				commit(CREATE_CHANNEL_SUCCESS);
			} catch (error) {
				commit(CREATE_CHANNEL_FAILURE, error);
			}
		},
	},
};